import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";
import { filterPlan } from "QuotePage/PlanFilters";
import _ from "underscore";

import { Option } from "Cobalt/Dropdown";
import { Popover } from "Cobalt/Popover";
import BodyText from "Common/BodyText";
import SICheckbox from "Common/SICheckbox";
import SIOverlayTrigger from "Common/SIOverlayTrigger";

import makeBem from "Utils/makeBem";

const bem = makeBem("SingleOptionFilter");

export default class SingleOptionFilter extends React.Component {
  render() {
    let {
      checked,
      uncheckedFilter,
      checkedFilter,
      filterKey,
      handleChangeFilter,
      filterLabel,
      filterTooltip,
      allPlans,
      filterConfig,
      disableFilterCountIndicator,
      underline,
      tooltipPlacement,
    } = this.props;

    // Set defaults for parameters not prespecified
    checked = checked || (filterConfig[filterKey] ? filterConfig[filterKey].include : false);

    const nextFilter = checked ? uncheckedFilter : checkedFilter;
    const popover = (
      <Popover showBackdrop={false} className="filter-tooltip" id={`${filterKey}_filter`}>
        <span dangerouslySetInnerHTML={{ __html: filterTooltip }} />
      </Popover>
    );

    const filterCount = this.getSimpleFilterCount(checkedFilter, filterKey, allPlans, filterConfig);

    let filterDisabled = null;
    let filterCountIndicator = null;
    // Disable filter if clicking it would result in a zero plan state
    if (filterKey === "network_name") {
      filterDisabled = false;
    } else if (filterKey === "is_company_eligible_for_plan") {
      filterDisabled = false;
      filterCountIndicator = (
        <BodyText muted className="absolute right-5 sm:hidden">
          &nbsp;({filterCount})
        </BodyText>
      );
    } else {
      filterDisabled = !checked && filterCount === 0;
      filterCountIndicator = (
        <BodyText muted className="absolute right-5 sm:hidden">
          &nbsp;({filterCount})
        </BodyText>
      );
    }

    if (disableFilterCountIndicator) {
      filterCountIndicator = null;
    }

    const handleOptionSelect = (e) => {
      // Make sure the click event doesn't propagate to parent elements
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }

      // Only apply the filter change if the checkbox isn't disabled
      if (!filterDisabled) {
        this.applyFilterChange(filterKey, nextFilter, filterDisabled);
      }
    };

    const checkbox = (
      <SICheckbox label={filterLabel} disabled={filterDisabled} checked={checked} popover={underline} onChange={handleOptionSelect} className="flex-1" />
    );

    const content = (
      <div className="flex items-center justify-between w-full">
        {filterTooltip ? (
          <SIOverlayTrigger trackType="filter" trackId={filterLabel} overlay={popover} placement={tooltipPlacement}>
            {checkbox}
          </SIOverlayTrigger>
        ) : (
          checkbox
        )}
        {filterCountIndicator}
      </div>
    );

    return (
      <Option
        className={classnames("p-4 sm:p-1 items-center justify-between", { "selected-filter-item": checked })}
        onClick={(e) => {
          // Stop propagation to prevent double-handling of the click
          e.stopPropagation();
          handleOptionSelect(e);
        }}
        disabled={filterDisabled}
      >
        {content}
      </Option>
    );
  }

  applyFilterChange = (filterKey, nextFilter, filterDisabled) => {
    const onChangeFilter = this.props.handleChangeFilter;
    if (filterDisabled) {
      return;
    }
    onChangeFilter(filterKey, nextFilter);
  };

  getSimpleFilterCount(checkedFilter, filterKey, allPlans, filterConfig) {
    const filter = {};
    filter[filterKey] = checkedFilter;

    const newFilters = _.extend({}, filterConfig, filter);

    return _.filter(allPlans, _.partial(filterPlan, newFilters)).length;
  }
}

SingleOptionFilter.propTypes = {
  filterKey: PropTypes.string.isRequired,
  uncheckedFilter: PropTypes.object,
  checkedFilter: PropTypes.object,
  handleChangeFilter: PropTypes.func.isRequired,
  filterLabel: PropTypes.string.isRequired,
  filterTooltip: PropTypes.string,
  allPlans: PropTypes.array.isRequired,
  filterConfig: PropTypes.object.isRequired,
  disableFilterCountIndicator: PropTypes.bool,
  underline: PropTypes.bool,
  tooltipPlacement: PropTypes.string,
};

SingleOptionFilter.defaultProps = {
  uncheckedFilter: {},
  checkedFilter: { include: [true] },
  disableFilterCountIndicator: false,
  underline: false,
  tooltipPlacement: "right",
};
